import {Grid, InputBase, Typography} from '@material-ui/core';
import React from 'react';
import CustomButton from '../../components/Button/Button';
import resumeData from '../../utils/resumeDate';
import useStyles from './styles';
import Zoom from 'react-reveal/Zoom';
import {useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import emailjs from "emailjs"

const Contact = () => {
  const classes = useStyles ();
  const theme = useTheme ();
  const isMobile = useMediaQuery (theme.breakpoints.down ('sm'));

  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  }

  return (
    <div>

      <Zoom>

        <Grid container className={classes.section} spacing={5}>

          {/* Title */}
          <Grid item xs={12} lg={7}>
            <Grid item className={classes.sectionTitle}>
              <span className={classes.span} />
              <h6 className={classes.sectionTitleText}>Contact Form</h6>
            </Grid>

            {/* Contact Form */}
            <Grid
              item
              xs={12}
            >
              <form className="contact-form" onSubmit={sendEmail}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputBase
                      name="name"
                      fullWidth
                      placeholder="Name"
                      variant="outlined"
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputBase
                      name="email"
                      fullWidth
                      placeholder="E-mail"
                      variant="outlined"
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputBase
                      name="message"
                      fullWidth
                      placeholder="message"
                      variant="outlined"
                      multiline
                      rows={4}
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid
                    style={{display: 'flex', justifyContent: 'center'}}
                    item
                    xs={12}
                  >
                    <CustomButton text="Submit" />
                  </Grid>
                </Grid>
              </form>

            </Grid>
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} lg={5}>
            <Grid container>
              <Grid item className={classes.sectionTitle}>
                <span className={classes.span} />
                <h6 className={classes.sectionTitleText}>
                  Contact Information
                </h6>
              </Grid>

              <Grid item xs={12} className={classes.contactInfo}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className={classes.contactItem}>
                      <span>Address: </span> <br></br>
                      <span>{resumeData.address}</span> 
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={classes.contactItem}>
                      <span>Phone: </span> <br></br>
                      <span>{resumeData.phone}</span> 
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography className={classes.contactItem}>
                      <span>Email: </span> <br></br>
                      <span>{resumeData.email}</span> 
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid
                  container
                  spacing={2}
                  className={classes.contactInfoSocialsContainer}
                >
                  {Object.keys (resumeData.socials).map (key => (
                    <Grid item className={classes.contactInfoSocial}>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        className={classes.a}
                        href={resumeData.socials[key].link}
                      >
                        {resumeData.socials[key].icon}
                      </a>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

            </Grid>
          </Grid>

        </Grid>

        {/* Google Map */}

        {isMobile
          ? <p>
              <iframe
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0071304699395!2d73.22099811490617!3d22.315570085315596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fcf70b4f2b7af%3A0xd2ca3834bcea0ed4!2sGhanshyam%20Park%20Society!5e0!3m2!1sen!2sin!4v1617992909247!5m2!1sen!2sin"
                width="300"
                height="300"
                loading="lazy"
              />
            </p>
          : <p>
              <iframe
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0071304699395!2d73.22099811490617!3d22.315570085315596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fcf70b4f2b7af%3A0xd2ca3834bcea0ed4!2sGhanshyam%20Park%20Society!5e0!3m2!1sen!2sin!4v1617992909247!5m2!1sen!2sin"
                width="850"
                height="450"
                loading="lazy"
              />
            </p>}

      </Zoom>
    </div>
  );
};

export default Contact;
